/* Modern Mercy conversion fixes — accurate variants, clear swatches and single-tap mobile cards. */
(() => {
  const colourMap = {
    'black':'#111111','black beauty':'#171717','washed black':'#242424','blackish green':'#202824',
    'gray':'#8a8a8a','grey':'#8a8a8a','dark gray':'#4b4b4b','dark grey':'#4b4b4b','light gray':'#c8c8c8','light grey':'#c8c8c8','flower gray':'#77756f','flower grey':'#77756f','pirate gray':'#55565a','pirate grey':'#55565a',
    'white':'#f5f3ed','off white':'#eee9dc','off-white':'#eee9dc','cream':'#e8ddc4',
    'red':'#b5262c','dark red':'#7a1f2b','rose red':'#a83246','wine red':'#6f1f2a','burgundy':'#6b1f2b','white with burgundy':'linear-gradient(135deg,#f4f0e8 0 58%,#6b1f2b 58% 100%)',
    'blue':'#345f91','royal blue':'#284d9b','sky blue':'#8fb9d2','navy':'#1e2b3f','navy blue':'#192a56','dark blue':'#1d3557','blue jeans':'#5b88b2','jeans blue':'#5b88b2','vintage blue':'#60798d',
    'green':'#4d684f','dark green':'#354b39','khaki':'#8a8065','beige':'#c8b99d','brown':'#745442','light apricot':'#ead6bd',
    'purple':'#70528d','pink':'#d68da4','rose pink':'#d68da4','orange':'#c87338','yellow':'#d0ad49','stainless steel':'#b7bcc2','gold plated':'#d4af37'
  };

  function paintSwatches() {
    document.querySelectorAll('.mmi-colour-swatch input').forEach((input) => {
      const key = (input.value || '').trim().toLowerCase();
      const fill = colourMap[key];
      const dot = input.closest('.mmi-colour-swatch')?.querySelector('.mmi-colour-swatch__dot');
      if (fill && dot) dot.style.setProperty('--swatch', fill);
    });

    document.querySelectorAll('.mm-swatch[data-value]').forEach((swatch) => {
      const key = (swatch.dataset.value || '').trim().toLowerCase();
      const fill = colourMap[key];
      if (!fill) return;
      swatch.style.background = fill;
      if (fill.startsWith('#')) swatch.style.backgroundColor = fill;
    });
  }

  // Keep the colour represented by the card/entry variant at the far left on initial load.
  // This is intentionally run only once: after the shopper starts browsing colours, the order stays stable.
  function pinEntryColourFirst() {
    document.querySelectorAll('.variant-fieldset--colour .mmi-pills--colour').forEach((row) => {
      const checked = row.querySelector('.mmi-colour-swatch input:checked');
      const label = checked?.closest('.mmi-colour-swatch');
      if (label && row.firstElementChild !== label) row.prepend(label);
    });
  }

  function setupSingleTapFlip() {
    if (!window.matchMedia('(hover: none), (pointer: coarse)').matches) return;

    let touchStart = null;
    const selector = 'a.product-card[href*="/products/"], a.wild-card[href*="/products/"]';

    document.addEventListener('touchstart', (event) => {
      if (event.touches.length !== 1) { touchStart = null; return; }
      const card = event.target.closest(selector);
      if (!card) { touchStart = null; return; }
      const touch = event.touches[0];
      touchStart = { card, x: touch.clientX, y: touch.clientY };
    }, { passive: true });

    document.addEventListener('touchend', (event) => {
      if (!touchStart || event.changedTouches.length !== 1) return;
      const { card, x, y } = touchStart;
      touchStart = null;
      const touch = event.changedTouches[0];
      if (Math.hypot(touch.clientX - x, touch.clientY - y) > 20 || !document.contains(card)) return;

      event.preventDefault();
      card.classList.add('mm-tap-flipping');
      const href = card.href;
      window.setTimeout(() => window.location.assign(href), 140);
    }, { passive: false });

    document.addEventListener('touchcancel', () => { touchStart = null; }, { passive: true });
  }

  function init() {
    paintSwatches();
    pinEntryColourFirst();
    setupSingleTapFlip();
  }

  document.addEventListener('DOMContentLoaded', init, { once: true });
  document.addEventListener('shopify:section:load', () => {
    paintSwatches();
    pinEntryColourFirst();
  });
})();